import WrapperComponent from '../components/hoc/Wrapper-component';
import { MainPage } from './welcome';
import { Warranty } from './warranty/warranty-list/Warranty';
import { WarrantyAdd } from './warranty/warraty-add/WarrantyAdd';
import { WarrantyEdit } from './warranty/warranty-edit/WarrantyEdit';
import { WarrantyView } from './warranty/warranty-view/WarrantyView';
import { ClaimList } from './claim/claim-list/ClaimList';
import { ClaimAdd } from './claim/claim-add/ClaimAdd';
import { ClaimEdit } from './claim/claim-edit/ClaimEdit';
import { ClaimView } from './claim/claim-view/ClaimView';
import { UserInfo } from './user-info/UserInfo';
import { StoreShop } from './store-shop/StoreShop';
import { ColorQr } from './product-warranty/color-qr/ColorQr';
import { Brand } from './product-warranty/brand/Brand';
import { Model } from './product-warranty/model/Model';
import { Product } from './product-warranty/product/Product';
import { EditProduct } from './product-warranty/edit-product/EditProduct';
import { ScanDelivery } from './scan-delivery/ScanDelivery';
import { CutOfWarranty } from './cut-of-warranty/CutOfWarranty';
import { ReportPage } from './report/ReportPage';
import { ReportClaim } from './report-claim/ReportClaim';
import { ReportCampaign } from './report-campaign/ReportCampaign';
import { UserPermission } from './permission/UserPermission';
import { GenQrCode } from './gen-qr/GenQrCode';

export default {
  MainPage: WrapperComponent('MainPage')(MainPage),
  Warranty: WrapperComponent('Warranty')(Warranty),
  WarrantyAdd: WrapperComponent('WarrantyAdd')(WarrantyAdd),
  WarrantyEdit: WrapperComponent('WarrantyEdit')(WarrantyEdit),
  WarrantyView: WrapperComponent('WarrantyView')(WarrantyView),
  ClaimList: WrapperComponent('ClaimList')(ClaimList),
  ClaimAdd: WrapperComponent('ClaimAdd')(ClaimAdd),
  ClaimEdit: WrapperComponent('ClaimEdit')(ClaimEdit),
  ClaimView: WrapperComponent('ClaimView')(ClaimView),
  UserInfo: WrapperComponent('UserInfo')(UserInfo),
  StoreShop: WrapperComponent('StoreShop')(StoreShop),
  ColorQr: WrapperComponent('ColorQr')(ColorQr),
  Brand: WrapperComponent('Brand')(Brand),
  Model: WrapperComponent('Model')(Model),
  Product: WrapperComponent('Product')(Product),
  EditProduct: WrapperComponent('EditProduct')(EditProduct),
  ScanDelivery: WrapperComponent('ScanDelivery')(ScanDelivery),
  CutOfWarranty: WrapperComponent('CutOfWarranty')(CutOfWarranty),
  ReportPage: WrapperComponent('ReportPage')(ReportPage),
  ReportClaim: WrapperComponent('ReportClaim')(ReportClaim),
  ReportCampaign: WrapperComponent('ReportCampaign')(ReportCampaign),
  UserPermission: WrapperComponent('UserPermission')(UserPermission),
  GenQrCode: WrapperComponent('GenQrCode')(GenQrCode),
};
